var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex min-vh-100 align-items-center justify-content-center logout"},[_c('p',[_vm._v("Logging out...")]),_c('BaseAppVersion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }